import { Button, Flex, Upload } from 'antd';
import styled from 'styled-components';

export const StyledUpload = styled(Upload)`
  height: calc(100% - 24px) !important;
  .ant-upload-list {
    width: 100% !important;
    height: 100% !important;
  }
  .ant-upload-select {
    position: relative;
    width: 100% !important;
    height: 100% !important;
    max-height: 218px !important;
    background-color: #fff !important;
    overflow: hidden;
  }

  &.fixed-width {
    .ant-upload-select {
      width: 187px !important;
    }
  }
`;

export const PreviewContainer = styled.div`
  width: 100% !important;
  height: 100% !important;
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  &:hover .mask {
    opacity: 1;
  }
`;

export const Mask = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: rgba(0, 0, 0, 0.45);
  opacity: 0;
  transition: opacity 0.2s ease;
`;

export const MaskButton = styled(Button).attrs({
  type: 'primary',
  shape: 'circle',
  size: 'large',
})`
  background: rgba(255, 255, 255, 0.85) !important;
  color: rgba(0, 0, 0, 0.85) !important;
  border: none !important;

  &:hover {
    background: rgba(255, 255, 255, 1) !important;
    color: rgba(0, 0, 0, 1) !important;
  }
`;

export const Placeholder = styled.p`
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  line-height: 22px;
  color: #c6c8ca;
`;
